export default "__VITE_ASSET__BdpD4ewS__"